var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.12119 5.57575C3.35551 5.34144 3.7354 5.34144 3.96972 5.57575L5.1818 6.78784L8.03027 3.93937C8.26458 3.70506 8.64448 3.70506 8.87879 3.93937C9.11311 4.17369 9.11311 4.55359 8.87879 4.7879L5.60607 8.06063C5.49354 8.17315 5.34093 8.23636 5.1818 8.23636C5.02267 8.23636 4.87006 8.17315 4.75754 8.06063L3.12119 6.42428C2.88688 6.18997 2.88688 5.81007 3.12119 5.57575ZM6 1.2C3.35421 1.2 1.2 3.35421 1.2 6C1.2 8.64579 3.35421 10.8 6 10.8C8.64579 10.8 10.8 8.64579 10.8 6C10.8 3.35421 8.64579 1.2 6 1.2ZM0 6C0 2.69147 2.69147 0 6 0C9.30853 0 12 2.69147 12 6C12 9.30853 9.30853 12 6 12C2.69147 12 0 9.30853 0 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.48287fef28f6060051d65fb37105d64c.svg";
export { ForwardRef as ReactComponent };